export const corporations = {
  Add_a_New_Company: "Agregar una nueva empresa",
  Add_Another_Admin: "Agregar otro administrador",
  Add_Company: "Agregar Empresa",
  Add_new_company: "Agregar nueva empresa",
  Companies: "Empresas",
  company_management: "administración de la empresa",
  Company_name: "Nombre de la empresa",
  "Created at": "Creado en",
  Edit_Company: "Editar Empresa",
  Name: "Nombre",
  Organisation_Admins: "Administradores de la organización",
  Please_enter_the_basic_company_information: "Por favor ingrese la información básica de la empresa",
  Status: "Estado",
  Update_company: "Actualizar empresa",
  Use_this_window_to_add_a_new_company_data_on_the_platform:
    "Utilice esta ventana para agregar datos de una nueva empresa en la plataforma",
  Use_this_window_to_edit_company_data_on_the_platform:
    "Utilice esta ventana para editar los datos de la empresa en la plataforma",
} as const;
